import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { map } from 'ramda';
import InstallmentsLearnMoreView from './InstallmentsLearnMoreView';
import { selectFinanceOffersByType } from 'state/financeOffers';

const InstallmentsLearnMore: React.FC = () => {
  const { installmentOffers } = useSelector(selectFinanceOffersByType);

  const maxCapacity = useMemo(() => {
    return Math.max(
      ...map(offer => offer.capacityValue / 100, installmentOffers || []),
      0,
    );
  }, [installmentOffers]);

  return <InstallmentsLearnMoreView maxCapacity={maxCapacity} />;
};

export default InstallmentsLearnMore;
